import { type MCPServerInfo } from '../../types';

const GenaiToolboxLookerServer: MCPServerInfo = {
  serverId: 'GENAI_TOOLBOX_LOOKER',
  name: 'MCP Toolbox for Looker',
  slug: 'genai-toolbox-looker',
  description:
    "Google's MCP Toolbox for Databases — Looker prebuilt. Connect to your Looker instance to explore Looks, run queries, and access LookML models via the Model Context Protocol.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/googleapis/genai-toolbox',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/googleapis/genai-toolbox'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['lookerBaseUrl', 'lookerClientId', 'lookerClientSecret'],
    properties: {
      lookerBaseUrl: {
        type: 'string',
        description:
          'Base URL of your Looker instance (e.g. https://mycompany.looker.com)',
        sensitive: false
      },
      lookerClientId: {
        type: 'string',
        description: 'Looker API client ID (from Admin > Users > API Keys)',
        sensitive: false
      },
      lookerClientSecret: {
        type: 'string',
        description: 'Looker API client secret',
        sensitive: true
      }
    }
  }
};

export default GenaiToolboxLookerServer;
